import React, { type ElementType, type ReactNode } from 'react';

type CsMaskProps = {
  children: ReactNode;
  /**
   * Element to render. Defaults to `span` for inline values (e.g. a balance
   * inside a heading). Use `div` to wrap block-level content such as a whole
   * transaction row.
   */
  as?: ElementType;
  className?: string;
};

/**
 * Marks sensitive customer data (balances, transaction amounts, PII) so that
 * ContentSquare masks it in session replay.
 *
 * The UK GTM container's single ContentSquare PII selector `[data-cs-mask]`
 * targets the `data-cs-mask` attribute set here, so anything wrapped in
 * `CsMask` (or any element carrying `data-cs-mask`) is obscured in replay
 * while layout and interactions are preserved.
 *
 * Audit tip: grep for `data-cs-mask` to find every masked value in the app.
 */
const CsMask: React.FC<CsMaskProps> = ({
  children,
  as: Tag = 'span',
  className,
}) => (
  <Tag data-cs-mask className={className}>
    {children}
  </Tag>
);

export default CsMask;
